import './new-person.scss';

import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import HeaderContent from "@shared/ui/header-content/header-content";
import FormPerson from "../form-person/form-person";
import { useNewPerson } from './new-person.hook';

export function NewPerson() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewPerson();

  return (
    <div id="NewPerson" className="person">
      <HeaderContent
        title="New Person"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormPerson />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewPerson;